"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M12 1a1 1 0 011-1h2a1 1 0 011 1v14a1 1 0 01-1 1h-2a1 1 0 01-1-1V1zM6 1a1 1 0 011-1h2a1 1 0 011 1v14a1 1 0 01-1 1H7a1 1 0 01-1-1V1zM0 1a1 1 0 011-1h2a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"];
//# sourceMappingURL=layout-three-columns.js.map